/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const strings = {
  attachments: {
    title: 'Course attachments',
    add: 'New attachment',
    count: (n) => (n === 0 ? 'No attachments' : `${n} attachment(s)`),
    nameAr: 'Arabic name',
    nameEn: 'English name',
    fileAr: 'Arabic file',
    fileEn: 'English file',
    keepExisting: 'Leave empty to keep the current file',
    noFiles: 'No files',
    nameRequired: 'Both the Arabic and English names are required',
    filesRequired: 'Both files are required when adding an attachment',
    edit: 'Edit',
    remove: 'Delete',
    removeConfirm: (name) => `The attachment "${name}" and its files will be deleted. This cannot be undone.`,
    save: 'Save',
    saving: 'Please wait...',
    empty: 'This course has no attachments',
    emptyHint: 'Add files the trainee can open alongside the course content.',
  },

  exceptions: {
    title: 'Exceptions List',
    hint: 'Extra exam tries, or more time, for named trainees on this course',
    add: 'New exception',
    type: 'Exception Type',
    types: {
      tries: 'Extra tries',
      until: 'More time',
      both: 'Both',
    },
    columns: {
      index: '#',
      user: 'Trainee',
      department: 'Department',
      tries: 'Number Of Tries',
      until: 'Can Attend Until',
    },
    triesHint: "The total allowed for this trainee, not a number added to the course's own",
    untilHint: 'The last day the trainee can enter the course',
    findUser: 'Find a trainee',
    findUserHint: 'By name, username or email',
    search: 'Search',
    searching: 'Please wait...',
    chosen: (n) => (n === 1 ? 'One trainee chosen' : `${n} trainees chosen`),
    usernames: 'Usernames',
    usernamesHint: 'Type the username; separate several with a comma',
    usersRequired: 'Choose at least one trainee',
    triesRequired: 'Enter the number of tries',
    triesRange: 'The number of tries must be between 1 and 100',
    untilPast: 'The end date must not be in the past',
    untilRequired: 'Choose the end date',
    edit: 'Update',
    remove: 'Delete',
    removeConfirm: (name) => `The exception for "${name}" will be removed from this course.`,
    save: 'Save',
    saving: 'Please wait...',
    empty: 'This course has no exceptions',
  },

  actionFailed: 'The operation could not be completed',
  // See the note in strings.ar.js.
  fail: {
    list: 'Could not load the learning programs',
    detail: 'Could not load the learning program',
    save: 'Could not save the learning program',
    copy: 'Could not copy the learning program',
    activate: 'Could not activate the learning program',
    disable: 'Could not disable the learning program',
    order: 'Could not save the learning program order',
    groups: 'Could not save the program departments',
    certificate: 'Could not save the program certificate',
    saveCourse: 'Could not save the course',
    deleteCourse: 'Could not delete the course',
    exam: 'Could not load the course exam settings',
    saveExam: 'Could not save the course exam',
    notification: 'Could not save the course notification',
    attachment: 'Could not complete the course attachment operation',
    exception: 'Could not complete the course exception operation',
  },
  title: 'Learning Programs Management',
  searchLabel: 'Search programmes by name',

  notify: {
    title: 'Send Notification',
    event: 'Notification',
    onStart: 'When the course starts',
    onEnd: 'When the course ends',
    when: 'Send time',
    inMinutes: 'After minutes',
    inDays: 'After days',
    onDate: 'On a specific date',
    minutes: 'Minutes',
    days: 'Days',
    date: 'Send date',
    delay: 'Delay between messages',
    delayHint: 'In seconds, to avoid the server refusing a large batch',
    whenRequired: 'Please choose when to send',
    note: 'The notification is sent to every trainee enrolled in the program',
    send: 'Send',
    sending: 'Please wait...',
  },

  ordering: {
    title: 'Learning Programs Ordering',
    hint: 'The order programs appear in for trainees',
    moveUp: 'Move up',
    moveDown: 'Move down',
    save: 'Save order',
    saving: 'Please wait...',
  },

  messages: {
    saved: 'Operation completed successfully',
    programSaved: 'Learning program saved',
    programCopied: 'Learning program copied',
    programActivated: 'Learning program activated',
    programDisabled: 'Learning program disabled',
    groupsSaved: 'Program departments saved',
    certificateSaved: 'Program certificate saved',
    notificationSaved: 'Course notification saved',
    programNotFound: 'Program not found',
    courseNotFound: 'Course not found in this program',
    attachmentNotFound: 'Attachment not found',
    nameTaken: 'A program with this name already exists',
    invalidInput: 'The data entered is not valid',
    requestFailed: 'An error occurred while processing the request',
  },

  actions: {
    create: 'New Program',
    quickCreate: 'Quick create',
    ordering: 'Learning Program Ordering',
  },

  shares: {
    success: 'Success Percentage',
    failure: 'Failure Percentage',
    incomplete: 'Uncompleted Percentage',
    incompleteNote: '(Attend at least one exam but did not complete other exams)',
    absent: 'Unattended Percentage',
    absentNote: '(Did not attend and any exam)',
  },

  columns: {
    name: 'Name',
    groups: 'Departments',
    courses: 'Courses',
    startDate: 'Start Date',
    endDate: 'End Date',
    status: 'Status',
  },

  row: {
    notify: 'Notifications',
    notifyDisabled:
      'Notification action is disabled, you can enable it from System Settings page under Notification Settings tab',
    edit: 'Update',
    report: 'Report',
    clone: 'Clone',
    delete: 'Delete',

    migrate: 'Migrate previous results',
  },

  course: {
    title: 'New Course',
    editTitle: 'Edit training course',
    steps: {
      info: 'Course Information',
      topics: 'Topics',
      exam: 'Exam Options',
    },
    level: 'Level',
    startDate: 'Start Date',
    endDate: 'End Date',
    contentType: 'Content Type',
    hasExam: 'Has Exam',
    banner: 'Upload Image File',
    scorm: 'Scorm Package File',
    rawamExam: 'Separate Rawam exam',
    rawamExamHint: 'Require a Rawam exam after this course, in addition to any quiz inside the ZIP.',
    scormHint: 'SCORM 1.2 ZIP with one learning object. Leave empty only when this language already has a package.',
    scormExamTopics: 'Select the question topics for the separate Rawam exam. The course content comes from the ZIP.',
    videoTopic: 'Video topic',
    scormQuestionBank: 'SCORM exam questions',
    questionBank: 'Question bank',
    scormZipRequired: 'Choose a SCORM ZIP package.',
    scormTooLarge: 'The SCORM ZIP must not exceed 100 MB.',
    scormEmpty: 'The SCORM ZIP is empty.',
    scormInstalled: 'Existing ZIPs are kept when their file fields are empty. Both languages must be installed before saving.',
    scormArabic: 'Arabic SCORM ZIP',
    scormEnglish: 'English SCORM ZIP',
    scormExistingLanguage: 'Language of the existing ZIP',
    scormChooseLanguage: 'Choose the language of the existing ZIP',
    packagesTitle: 'Course packages',
    packagesHint: 'One SCORM 1.2 ZIP per language, each with a single learning object. Leave a language empty only if its package is already installed.',
    scormLimit: 'SCORM 1.2, up to 100 MB',
    packageInstalled: 'Package installed',
    packageReplacing: 'The new file replaces the installed package when you save',
    replaceFile: 'Replace file',
    examTopicsTitle: 'Assessment topics',
    topicsSelected: (count) => `${count} selected`,
    topicsNoMatch: 'No topics match your search',
    scormBadge: 'SCORM',
    contentTypeLocked: 'The content type cannot change once the course exists.',
    file: 'File',
    yes: 'Yes',
    no: 'No',
    passLimit: 'Success Percentage',
    examTries: 'Allowed Tries Count',
    questionsCount: 'Questions Count',
    rewatchPercentage: 'Percentage of forcing the user to rewatch the content',
    rewatchHint:
      'To force a user who fails to re-watch the content, set a value between 1 and a percentage lower than the passing score.',
    forceWatch: 'Forced to watch content before the test',
    hideAnswers: 'Hide the correct answers if you do not pass the test',
    preventIfSuccess: 'Preventing re-entry for the exam in case of success',
    quizEnable: 'Activate the quiz test after viewing the topic',
    topicsRequired: 'Choose at least one topic',
    topicsNote:
      'While updating the course, when adding or removing topics, you have to update the exam question rules yourself accordingly',
    searchTopics: 'Search the topics',
    publicity: 'Publicity',
    publicityAll: 'All',
    public: 'Public',
    private: 'Private',
    order: 'Topic order',
    orderHint: 'The order the topics run in inside the course',
    orderEmpty: 'No topic chosen yet',
    moveUp: 'Move earlier',
    moveDown: 'Move later',
  },

  form: {
    quickTopicsOnly: 'Quick create makes topic-based courses and Rawam exams. To upload a SCORM ZIP, create the program first, then add a SCORM course.',
    editTitle: 'Edit training program',
    identity: 'Name and description',
    visibility: 'Course visibility',
    arabicName: 'Arabic Name',
    englishName: 'English Name',
    arabicDescription: 'Arabic Description',
    englishDescription: 'English Description',
    pastCourses: 'Finished courses',
    futureCourses: 'Future courses',
    pastViews: {
      show: 'Show',
      hide: 'Hide',
      disabled: 'Disabled',
      showButNoExam: 'Show, with the exam disabled',
    },
    futureViews: {
      show: 'Show',
      hide: 'Hide',
      disabled: 'Show as locked until the start date',
      showButNoExam: 'Show, with the exam disabled',
      allowIfWatchedPrevious: 'Unlock after the previous one is watched',
    },
    allowLateCourses:
      'Allow a new course to be added to the program after some users have already passed or failed',
    allowLateCoursesNote:
      'Users who have already finished the program keep their pass status',

    steps: {
      identity: 'Program details',
      visibility: 'Course visibility',
      topics: 'Choosing topics',
      options: 'Setting options',
    },
    topics: 'Available Topics',
    topicsHint: 'Topics available for creating training courses. Only topics with exam questions are listed.',
    topicsRequired: 'Choose at least one topic',
    topicsChosen: 'selected',
    coursesMade: (made, total) => `${made} of ${total} courses created`,
    selectAll: 'Select All',
    clearAll: 'Clear selection',
    courseOptions: 'Courses Options',
    passLimit: 'Success Percentage',
    questionsCount: 'Questions Count',
    startDate: 'Start Date',
    endDate: 'End Date',
    range: 'That value is outside the allowed range',
    dateOrder: 'The end date must fall after the start date',
    quickTitle: 'Quick create',
    quickSubtitle: 'A program, its courses and their exams, in three steps',
    save: 'Save',
    close: 'Close',
    required: 'Field required',
    nameLetters: 'The name must contain letters, not only symbols or digits',
    nameTaken: 'Another learning program already uses this name',
    tooLong: (max) => `Must not exceed ${max} characters`,
    saved: 'Operation Completed Successfully',
  },

  migrate: {
    confirm: 'Migrate the course results for this program? This can take several minutes.',
    migratedCount: 'Users migrated: ',
    failed: 'Something went wrong during the operation',
  },

  status: {
    active: 'Active',
    inactive: 'Inactive',
    expired: 'Expired',
  },

  detail: {
    title: 'Update Learning Program',
    back: 'Back',

    errorHeading: 'Error Message',
    edit: 'Update',
    forceRetake: 'Force users to retak program',
    clone: 'Clone',
    active: 'Active',

    cards: {
      groups: 'Departments',
      survey: 'Survey',
      certificate: 'Certificate',
    },

    setUp: 'Set up',
    groupsPanel: {
      title: 'Programme departments',
      legend: 'Assigned departments',
      selectAll: 'Select all',
      filter: 'Search for a department',
      assignNew: 'Assign new departments automatically',
      noneChosen: 'Choose at least one department',
      assignNewHint: 'A department added later by the directory sync is assigned to this programme',
    },
    certificatePanel: {
      title: 'Programme certificate',
      certificate: 'Certificate template',
      certificateHint: 'The template this programme’s certificate is printed on',
      certificateRequired: 'Choose a certificate template',
      printLanguage: 'Print language',
      languages: { arabic: 'Arabic', english: 'English', ui: 'Interface language' },
      userPrint: 'Let the trainee print the certificate',
      emailSend: 'Send the certificate by email',
      personalEmail: 'Send to the personal address',
      departmentName: 'Show the department name',
      grade: 'Show the grade',
      gradeA: 'Excellent threshold',
      gradeB: 'Very good threshold',
      gradeC: 'Good threshold',
      gradeOrder: 'Excellent must be above Very good, and Very good above Good',
      dateConfig: 'Programme end date',
      dateConfigs: {
        lastCourse: 'Last course',
        lastExam: 'Last exam',
        programEndLastCourse: 'Programme end date or last course',
        programEndLastExam: 'Programme end date or last exam',
      },
      dateFormat: 'Date format',
      dateFormats: { gregorian: 'Gregorian', hijri: 'Hijri', both: 'Both', ui: 'Interface language' },
      validityType: 'Certificate validity',
      validity: {
        never: 'Never expires',
        days: 'By days',
        months: 'By months',
        years: 'By years',
        period: 'Validity period',
        positive: 'Enter a validity period greater than zero',
        visibility: 'Validity visibility',
        adminsAndUsers: 'Admins and trainees',
        adminsOnly: 'Admins only',
        usersOnly: 'Trainees only',
      },
    },
    surveyPanel: {
      title: 'Programme survey',
      steps: { info: 'Survey info', properties: 'Survey properties', questions: 'Survey questions' },
      next: 'Next',
      loading: 'Loading…',
      nameAr: 'Arabic name',
      nameEn: 'English name',
      descriptionAr: 'Arabic description',
      descriptionEn: 'English description',
      targetNote: 'This survey belongs to this training programme.',
      enabled: 'Enable the survey',
      enabledHint: 'Trainees see it only once it is enabled and has questions',
      mandatory: 'Mandatory survey',
      timeRestricted: 'Limit the survey period',
      startDate: 'Start date',
      endDate: 'End date',
      groups: 'Target departments',
      selectAll: 'Select all',
      filter: 'Search for a department',
    },

    coursesTitle: ' Courses on Programs',
    newCourse: 'New Course',
    importScorm: 'Import SCORM ZIP',
    scormImportHint: 'Import a portable ZIP with Arabic and English lessons, exam questions and a PNG cover.',
    scormImportInactive: 'Deactivate this program before importing a SCORM course.',
    scormImportInvalid: 'Choose a portable SCORM ZIP smaller than 201 MB.',
    scormImportSuccess: 'SCORM course imported. Review it before activating the program.',
    scormImportFailed: 'Could not import this SCORM course.',
    scormExportFailed: 'Could not export this SCORM course.',

    columns: {
      index: 'ID',
      course: 'Course',
      content: 'Content',
      exam: 'Exam',
      startDate: 'Start Date',
      endDate: 'End Date',
    },

    courseRow: {
      exportScorm: 'Export portable SCORM ZIP',
      edit: 'Update',
      notify: 'Notifications',
      notifyDisabled:
        'Notification action is disabled, you can enable it from System Settings page under Notification Settings tab',
      delete: 'Delete',
      survey: 'Survey',
      attachments: 'Manage Attachments',
      exceptionsList: 'Exceptions List',
      setExceptions: 'Set Exceptions',
      addExam: 'Add Exam',
      editExam: 'Update Exam',
    },

    deleteCourseConfirm: 'The course, its exam and its trainees’ results will be deleted. This cannot be undone.',
  },

  deleteConfirm: 'Deletes the program, its courses and all trainee results. Permanently.',
  deleteByName: 'To confirm write down the program name',

  cloneTitle: 'Clone learning program',
  cloneConfirm: 'This will duplicate the selected program and create a new one from it. Do you want to continue?',

  deleted: 'Operation Completed Successfully',
  close: 'Close',
}

/** Programme reports. */
export const reportsStrings = {
  title: 'Programme Reports',
  subtitle: "A programme's results, its courses, and its survey answers",
  chooseProgram: 'Choose a programme to see its report',
  notFound: 'This programme does not exist',
  notFoundHint: 'Choose another programme from the list',
  reversedRange: 'The end date must be after the start date',
  actionFailed: 'The operation could not be completed',
  export: 'Export Report',
  exportSuccess: 'Report exported successfully',
  fail: {
    page: 'Could not load the learning program reports',
    export: 'Could not export the learning program report',
  },

  filter: { program: 'Programme', from: 'From', to: 'To' },

  tabs: {
    info: 'Programme info',
    courses: 'Course results',
    survey: 'Survey results',
    results: 'Programme results',
    certificates: 'Print certificates',
  },

  shares: {
    success: 'Passed',
    failure: 'Failed',
    incomplete: 'Incomplete',
    absent: 'Did not attend',
  },

  people: {
    title: 'Trainees',
    tabs: { success: 'Passed', failure: 'Failed', incomplete: 'Incomplete', absent: 'Did not attend', groups: 'Departments' },
    index: '#',
    user: 'Trainee',
    department: 'Department',
    email: 'Email',
    examDate: 'Exam date',
    degree: 'Score',
    watched: 'Watched',
    users: 'Users',
    search: 'Search trainees',
    searchGroups: 'Search departments',
    empty: 'No data',
  },

  stats: {
    caption: 'Programme summary',
    courses: 'Courses',
    groups: 'Departments',
    users: 'Users',
  },

  courses: {
    title: 'Courses',
    name: 'Course',
    startDate: 'Start',
    endDate: 'End',
    topics: 'Topics',
    success: 'Passed',
    failure: 'Failed',
    absent: 'Absent',
    empty: 'This programme has no courses',
    chart: 'Outcome per course',
    chartHint: 'One bar per course, the whole of its audience: passed, failed and absent. Lowest pass share first.',
  },

  survey: {
    title: 'Survey results',
    question: 'Question',
    answer: 'Answer',
    count: 'Count',
    empty: 'No survey answers yet',
  },
}
